/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  UpdateTimesheetEntryMutationRequest,
  UpdateTimesheetEntryMutationResponse,
  UpdateTimesheetEntryPathParams,
} from '../models/UpdateTimesheetEntry.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  updateTimesheetEntryMutationResponseSchema,
  updateTimesheetEntryMutationRequestSchema,
} from '../zod/updateTimesheetEntrySchema.ts';
import { useMutation } from '@tanstack/react-query';

export const updateTimesheetEntryMutationKey = () =>
  [{ url: '/api/entries/:id' }] as const;

export type UpdateTimesheetEntryMutationKey = ReturnType<
  typeof updateTimesheetEntryMutationKey
>;

/**
 * {@link /api/entries/:id}
 */
export async function updateTimesheetEntry(
  id: UpdateTimesheetEntryPathParams['id'],
  data: UpdateTimesheetEntryMutationRequest,
  config: Partial<RequestConfig<UpdateTimesheetEntryMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = updateTimesheetEntryMutationRequestSchema.parse(data);
  const res = await request<
    UpdateTimesheetEntryMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateTimesheetEntryMutationRequest
  >({
    method: 'PUT',
    url: `/api/entries/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return updateTimesheetEntryMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/entries/:id}
 */
export function useUpdateTimesheetEntry<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateTimesheetEntryMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: UpdateTimesheetEntryPathParams['id'];
        data: UpdateTimesheetEntryMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<UpdateTimesheetEntryMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? updateTimesheetEntryMutationKey();

  return useMutation<
    UpdateTimesheetEntryMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: UpdateTimesheetEntryPathParams['id'];
      data: UpdateTimesheetEntryMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return updateTimesheetEntry(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
